import { Injectable, OnDestroy } from '@angular/core';
import {
  BehaviorSubject,
  combineLatest,
  filter,
  map,
  shareReplay,
  startWith,
} from 'rxjs';
import { Certificates } from 'server/shared/collections/certificates';
import { Certificate } from 'server/shared/models/certificate';
import { rxDistinctArrayByField } from 'src/helpers/rxDistinctStringArray';
import { CustomerService } from './customer.service';

@Injectable({
  providedIn: 'root',
})
export class CertificateService implements OnDestroy {
  allCertificates$ = new BehaviorSubject<Certificate[] | undefined>(undefined);

  readyCertificates$ = combineLatest([
    this.allCertificates$.pipe(filter(Boolean)),
    this.customerService.customersOfUser$.pipe(startWith(undefined)),
  ]).pipe(
    map(([allCertificates, customers]) => {
      if (
        !customers?.length ||
        customers?.some((customer) => !customer.visibleCertificates?.length)
      ) {
        return allCertificates;
      }
      const visibleCertificates = new Set(
        customers?.flatMap((customer) => customer.visibleCertificates!),
      );
      return allCertificates.filter((certificate) =>
        visibleCertificates.has(certificate._id),
      );
    }),
    rxDistinctArrayByField((certificate) => certificate._id),
    shareReplay(1),
  );

  private certificatesTracker?: Tracker.Computation;

  constructor(private customerService: CustomerService) {
    this.certificatesTracker = Tracker.autorun(() => {
      let certificates = Certificates.find().fetch();
      this.allCertificates$.next(certificates || undefined);
    });
  }

  ngOnDestroy() {
    if (this.certificatesTracker) {
      this.certificatesTracker.stop();
    }
  }
}
